(() => {
  const message = 'Hallo Smid Project, ik heb een vraag.';
  const prepare = (link) => {
    if (!link) return;
    try {
      const url = new URL(link.href, location.origin);
      if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return;
      if (!url.searchParams.get('text')) {
        url.searchParams.set('text', message);
        link.href = url.href;
      }
    } catch (_) { /* Leave other links untouched. */ }
  };
  const scan = (root) => root.querySelectorAll('a[href]').forEach(prepare);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('click', (event) => prepare(event.target.closest?.('a[href]')), true);
})();
